/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInvestingMetrics} from '../api'

 export const useQueryGetInvestingMetrics = createReactQueryHook('getInvestingMetrics', getInvestingMetrics)
